import { useEffect, useState } from 'react'
import { Contador } from '../assets/services/Contador.ts'

export function ComponentContador(props: { className?: string, contador: Contador }) {
  const cl = props.className || 'text-amber-400'
  const [time, setTime] = useState(() => props.contador.tempoPassado(new Date()))
  
  useEffect(() => {
    const updateTime = () => {
      setTime(props.contador.tempoPassado(new Date()))
    }
    updateTime()
    
    const interval = setInterval(updateTime, 100)
    
    return () => clearInterval(interval)
  }, [props.contador])
  
  return <div className={cl}>{time}</div>
}